// echarts v6 redesigned the default theme (palette, component positions/sizes).
// Importing 'echarts/theme/v5' registers the official 'v5' theme which restores
// the previous look. Pass ECHARTS_V5_THEME to every echarts init() call.
import 'echarts/theme/v5';

export const ECHARTS_V5_THEME = 'v5';

// v6 makes label.rich tokens inherit font styles from the plain label; spread into
// the option root of charts using label.rich to keep v5 behavior. The flag isn't in
// echarts' published types, but spread properties are exempt from TS excess-property
// checks, so typed option literals still compile (an inline key would not).
export const RICH_LABEL_V5_COMPAT = { richInheritPlainLabel: false } as const;
